import { ReactNode } from "react";
import { HILERIQ_URL, HILERIQ_LABEL } from "@/lib/hileriq";

interface HilerIQLinkProps {
  children?: ReactNode;
  className?: string;
  ariaLabel?: string;
}

/**
 * Single shared entry point to the HilerIQ platform.
 * HilerIQ is first-party, so this deliberately skips the external-link
 * interstitial used for unrelated third-party destinations.
 */
const HilerIQLink = ({ children, className, ariaLabel }: HilerIQLinkProps) => (
  <a
    href={HILERIQ_URL}
    target="_blank"
    rel="noopener"
    className={className}
    aria-label={ariaLabel}
  >
    {children ?? HILERIQ_LABEL}
  </a>
);

export default HilerIQLink;